import React from 'react';

export const Preferences = () => {
    return (
        <div>
            Preferences Page
        </div>
    );
};